import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, input, output, computed, signal, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'lib-input-field',
  imports: [CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFieldComponent),
      multi: true,
    }
  ],
  templateUrl: './input-field.html',
})
export class InputFieldComponent implements ControlValueAccessor{
  type = input<string>('text');
  id = input<string>('');
  name = input<string>('');
  placeholder = input<string>('');
  value = '';
  min = input<string>('');
  max = input<string>('');
  step = input<number>();
  disabled = false;
  success = input<boolean>(false);
  error = input<boolean>(false);
  hint = input<string>('');
  className = input<string>('');

  valueChange = output<string | number>();
  showPassword = signal(false);

  calculatedType = computed( () => {
    if(this.type() === "password" && this.showPassword()) return "text";
    return this.type();
  })

  get inputClasses(): string {
    let inputClasses = `h-11 w-full rounded-lg border appearance-none px-4 py-2.5 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-hidden focus:ring-3 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 ${this.className()}`;

    if (this.disabled) {
      inputClasses += ` text-gray-500 border-gray-300 opacity-40 bg-gray-100 cursor-not-allowed dark:bg-gray-800 dark:text-gray-400 dark:border-gray-700 opacity-40`;
    } else if (this.error()) {
      inputClasses += ` border-error-500 focus:border-error-300 focus:ring-error-500/20 dark:text-error-400 dark:border-error-500 dark:focus:border-error-800`;
    } else if (this.success()) {
      inputClasses += ` border-success-500 focus:border-success-300 focus:ring-success-500/20 dark:text-success-400 dark:border-success-500 dark:focus:border-success-800`;
    } else {
      inputClasses += ` bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring-brand-500/20 dark:border-gray-700 dark:text-white/90  dark:focus:border-brand-800`;
    }
    return inputClasses;
  }

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  
  handleInput(event: Event){
    const next = (event.target as HTMLInputElement).value;
    this.value = next;
    this.onChange(next);
  }

  toggleShowPassword(){
    if(this.disabled) return;
    this.showPassword.update(val => !val)
  }

}
